import { render, staticRenderFns } from "./briefing-register-form.vue?vue&type=template&id=04fa117a&"
import script from "./briefing-register-form.vue?vue&type=script&lang=js&"
export * from "./briefing-register-form.vue?vue&type=script&lang=js&"
import style0 from "./briefing-register-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports